import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { DELETE_CUSTOM_FILTER_ERROR_MESSAGE } from '../constants';
import { DELETE_TRAFFICKING_CUSTOM_FILTER } from '../mutations/deleteTraffickingCustomFilter';
import type {
  DeleteTraffickingCustomFilterMutationResponse,
  DeleteTraffickingCustomFilterMutationVariables,
} from '../types';

type UseDeleteCustomFilterResult = {
  deleteFilter: (id: string) => Promise<void>;
  loading: boolean;
  error: Error | undefined;
};

export function useDeleteCustomFilter(): UseDeleteCustomFilterResult {
  const [mutate, { loading, error }] = useMutation<
    DeleteTraffickingCustomFilterMutationResponse,
    DeleteTraffickingCustomFilterMutationVariables
  >(DELETE_TRAFFICKING_CUSTOM_FILTER, {
    refetchQueries: ['GET_TRAFFICKING_CUSTOM_FILTERS'],
  });

  const deleteFilter = useCallback(
    async (id: string): Promise<void> => {
      const result = await mutate({ variables: { id } });
      if (!result.data?.deleteTraffickingCustomFilter) {
        throw new Error(DELETE_CUSTOM_FILTER_ERROR_MESSAGE);
      }
    },
    [mutate]
  );

  return { deleteFilter, loading, error };
}
